
import flowerImg from "../../assets/images/shop/flower.png"
import oldDiamondImg from "../../assets/images/myInvites/card4.png"
import newDiamondImg from "../../assets/images/shop/newDiamond.png"
import progressRight from "@/assets/images/refining/progressRight.png"
import selectedImg from "../../assets/images/selectActive.png"
import starGreenImg from "../../assets/images/rules/star.png"
import BuyComp from '../../components/common/BuyComp.js';
import { useTranslation } from "react-i18next"


interface PropType {
    dataList: any[]
}
const Regenerate = ({ dataList }: PropType) => {
    const { t } = useTranslation();
    return (

        <div className="relative mt-[20px]">
            <div className="absolute top-[20px] w-[15px] h-[310px] bg-gradient-to-t to-[#347F7A] from-[#132D2B]  rounded-tr-[20px] border-r border-[#376E89] "></div>
            <div className="absolute top-[20px] right-0 w-[15px] h-[310px] bg-gradient-to-t rounded-tl-[20px] border-l border-[#376E89] to-[#1E1E4C] from-[#132D2B]"></div>
            <div className='px-[30px] relative bg-cover bg-no-repeat h-[320px] w-full '>
                <div className="border h-[300px] pt-2 flex flex-col px-4 items-center justify-center border-[#00E49F] bg-gradient-to-t to-[#376196] from-[#132D2B] rounded-tl-[20px] rounded-tr-[20px]">
                    <div className='w-[80%] flex justify-around items-center relative'>
                        <img className='w-[50px] h-[70px]' src={oldDiamondImg} alt="" />
                        <div className='text-center'>
                            <p className='text-white text-sm'>{t("shop.regen")}</p>
                            <div className="w-[94px] mt-1 overflow-hidden flex">

                                <img className=" w-[94px] translate-x-[-94px] progressRight_1 " src={progressRight} alt="" />
                                <img className=" w-[94px] translate-x-[-94px] progressRight_2 " src={progressRight} alt="" />
                            </div>
                        </div>

                        <img className='w-[50px] h-[70px]' src={newDiamondImg} alt="" />
                    </div>
                    <div className='flex items-center'>
                        <img className='w-3 h-3 mr-2' src={selectedImg} alt="" />
                        <p className='text-white text-xs'>{t("shop.chance")}</p>
                    </div>
                    <div className="text flex-1 text-left mt-3">
                        <p className='text-sm text-shadow-lg text-[#24E1FF] flex items-start'><img className='w-3 h-3 mr-2 mt-1' src={starGreenImg} alt="" />{t("shop.ifyou")} </p>
                        <p className='text-sm text-shadow-lg text-[#24E1FF] flex items-start'><img className='w-3 h-3 mr-2 mt-1' src={starGreenImg} alt="" />{t("shop.below")}</p>
                        <p className='text-sm text-shadow-lg text-[#24E1FF] flex items-start'><img className='w-3 h-3 mr-2 mt-1' src={starGreenImg} alt="" />{t("shop.after")}</p>
                    </div>

                </div>

            </div>

            <div className='w-full grid grid-cols-1 gap-4 absolute top-[290px] rounded-tr-[40px] rounded-tl-[40px] px-4 pt-[30px] bg-gradient-to-t from-[#092524] to-[#1C514E]'>
                {
                    dataList.map((item: any, index) => {
                        return (
                            <div key={index}>
                                {
                                    item.length > 0 && <div key={index} className='relative w-full flex items-center justify-between px-4 py-2 h-[90px] rounded-[20px] special-class'>
                                        <div>
                                            <div className={`${item[0].discount <= 0 ? 'hidden' : ''} w-8 absolute -top-1 -left-0 flex justify-center items-center`}>
                                                <img className='w-8' src={flowerImg} alt="" />
                                                <span className='absolute text-xs text-white'>{item[0].discount}%</span>
                                            </div>
                                            <div className='flex flex-1 items-center justify-center'>
                                                <p className='text-sm font-[900] text-white'>{t("shop.inclu")}<span className='text-transparent bg-clip-text bg-gradient-to-r from-[#00E49F] to-[#54ADFF]'> {item[0].count} {t("shop.time")}</span>  {t("shop.forre")}</p>
                                            </div>
                                        </div>
                                        <div className="w-[132px]">
                                            <BuyComp info={item} title={t("shop.regen") + t("shop.chances")}></BuyComp>
                                        </div>
                                    </div>
                                }
                            </div>

                        )
                    })
                }
            </div>
        </div>


    )
}


export default Regenerate;